import React, { Component } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Layout from "../../components/Layout";
import FormSB from "../../components/Form";

export default class Contato extends Component {

    componentDidMount() {
        document.title = "Site Blindado - Contato";
    }

    render() {
        return (
            <Layout>
                <div className="padding-container padding-top-mobile bg-dark-green">
                    <Container>
                        <Row className="h-100 align-items-center">
                            <Col xs={12} md={8}>
                                <h1 className="font-black mb-4">Contato</h1>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="padding-container">
                    <Container>
                        <Row className="align-items-center">
                            <Col xs={12} md={12}>
                                <FormSB color="white" type="form-contact" title="Entre em Contato" description={<>Preencha o formulário caso tenha qualquer dúvida sobre o seu serviço contratado que nossa equipe entrará em contato com você <span className="font-semi-bold color-primary">o mais rápido possível</span>.</>} />
                            </Col>
                        </Row>
                    </Container>
                </div>
            </Layout>
        );
    }
}